import type { PlayerQueryParams } from '../PlayerEmbedSettings.types';

export class EmbedPlayerUtility {
  /**
   * Create a player embed url with the given query params.
   * @param src - The player src url, preferred from GET VIDEO clip.playEmbedUrl
   * @param initialQueryParams - The initial query params, preferred from GET VIDEO clip.page.player if the embed supposed to support Page Appearance
   * @returns The player embed url.
   */
  static createEmbedUrl(src: string, initialQueryParams?: PlayerQueryParams) {
    if (!src) return '';
    if (!initialQueryParams) return src;

    const url = new URL(src);

    (Object.keys(initialQueryParams) as Array<keyof PlayerQueryParams>).forEach((key) => {
      url.searchParams.set(key, String(initialQueryParams[key]));
    });

    return url.href;
  }
}
